import { createAction } from '@reduxjs/toolkit'
import { ShowModalType } from '@/scenes/engine/common/constants'
import { ModalCustomTextProps } from './reducer'

export const setShowModalType = createAction<ShowModalType | null>('modal/setShowModalType')
export const setCustomTextModal = createAction<ModalCustomTextProps>('modal/setCustomTextModal')
export const setWhatsNewData = createAction<any[]>('modal/setWhatsNewData')
